module.exports = __webpack_public_path__ + "static/img/ios.2db6251f.png";